export enum AppHomeManagerStatus {
  RequiresInit,
  Starting,
  Running,
  Stopped,
}
